import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "components/shadcn/ui/tooltip";

interface GenericTooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const ToolTipWrapper: React.FC<GenericTooltipProps> = ({
  content,
  children,
  className,
}) => {
  const isContent = content && content !== "";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={className}>{children}</span>
        </TooltipTrigger>
        {isContent && <TooltipContent>{content}</TooltipContent>}
      </Tooltip>
    </TooltipProvider>
  );
};

export default ToolTipWrapper;
